/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdTransitionProps } from './type';
const props: TdTransitionProps = {
  /** 首次出现是否展示动画 */
  appear: {
    type: Boolean,
    value: false,
  },
  /** 隐藏时是否销毁内容 */
  destoryOnHide: {
    type: Boolean,
    value: false,
  },
  /** 指定过渡时间 */
  durations: {
    type: null,
  },
  /** 过渡类名 */
  name: {
    type: String,
    value: 't-transition',
  },
  /** 是否显示 */
  visible: {
    type: Boolean,
    value: false,
  },
};

export default props;
